/**
 * DemocratCharts — symbol catalog.
 *
 * Curated list of common tickers for the search dropdown. Custom symbols
 * (anything the user types) are also allowed — this is just for discovery.
 *
 * Phase 2.2+ will replace this with /api/instruments fetched from Kite's
 * instruments.csv on VM-1.
 */

export interface SymbolEntry {
  symbol: string;
  exchange: string;
  name: string;
  category: "Indian Index" | "Indian Equity" | "US Equity" | "Crypto" | "Derivatives";
}

export const SYMBOLS: SymbolEntry[] = [
  // ── Indian Indices ──
  { symbol: "NIFTY",     exchange: "INDEX",  name: "Nifty 50",           category: "Indian Index" },
  { symbol: "BANKNIFTY", exchange: "INDEX",  name: "Nifty Bank",         category: "Indian Index" },
  { symbol: "SENSEX",    exchange: "INDEX",  name: "BSE Sensex",         category: "Indian Index" },

  // ── Indian Equity (top NSE liquidity) ──
  { symbol: "RELIANCE",  exchange: "NSE",    name: "Reliance Industries", category: "Indian Equity" },
  { symbol: "TCS",       exchange: "NSE",    name: "Tata Consultancy",    category: "Indian Equity" },
  { symbol: "HDFCBANK",  exchange: "NSE",    name: "HDFC Bank",           category: "Indian Equity" },
  { symbol: "INFY",      exchange: "NSE",    name: "Infosys",             category: "Indian Equity" },
  { symbol: "ICICIBANK", exchange: "NSE",    name: "ICICI Bank",          category: "Indian Equity" },
  { symbol: "SBIN",      exchange: "NSE",    name: "State Bank of India", category: "Indian Equity" },
  { symbol: "BHARTIARTL",exchange: "NSE",    name: "Bharti Airtel",       category: "Indian Equity" },
  { symbol: "ITC",       exchange: "NSE",    name: "ITC Ltd",             category: "Indian Equity" },
  { symbol: "LT",        exchange: "NSE",    name: "Larsen & Toubro",     category: "Indian Equity" },
  { symbol: "AXISBANK",  exchange: "NSE",    name: "Axis Bank",           category: "Indian Equity" },

  // ── US Equity ──
  { symbol: "AAPL",      exchange: "NASDAQ", name: "Apple",               category: "US Equity" },
  { symbol: "MSFT",      exchange: "NASDAQ", name: "Microsoft",           category: "US Equity" },
  { symbol: "GOOGL",     exchange: "NASDAQ", name: "Alphabet Class A",    category: "US Equity" },
  { symbol: "AMZN",      exchange: "NASDAQ", name: "Amazon",              category: "US Equity" },
  { symbol: "META",      exchange: "NASDAQ", name: "Meta Platforms",      category: "US Equity" },
  { symbol: "NVDA",      exchange: "NASDAQ", name: "NVIDIA",              category: "US Equity" },
  { symbol: "TSLA",      exchange: "NASDAQ", name: "Tesla",               category: "US Equity" },
  { symbol: "NFLX",      exchange: "NASDAQ", name: "Netflix",             category: "US Equity" },
];

export const TIMEFRAMES: { value: string; label: string }[] = [
  { value: "1m",  label: "1m" },
  { value: "5m",  label: "5m" },
  { value: "15m", label: "15m" },
  { value: "1h",  label: "1h" },
  { value: "4h",  label: "4h" },
  { value: "1d",  label: "1D" },
  { value: "1w",  label: "1W" },
];

/** Map timeframe → sensible default lookback in days. */
export const TIMEFRAME_DEFAULT_DAYS: Record<string, number> = {
  "1m":  5,
  "5m":  30,
  "15m": 60,
  "1h":  120,
  "4h":  365,
  "1d":  365,
  "1w":  1825, // ~5 years
};
